import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FC, useCallback } from "react";
import { AppCalloutBannerContent } from "@/components/banners/app-callout-banner/app-callout-banner-content";
import { trackEvent } from "@/domains/metrics";
import { TrackedEvent } from "@/domains/metrics";

interface AppCalloutBannerProps {}

export const AppCalloutBanner: FC<AppCalloutBannerProps> = observer(() => {
  const { store } = useAppStore();

  const appCallout = store.spaceAccountAppCallouts.highestPriorityVisibleBanner;

  const handleDismiss = useCallback(async () => {
    if (!appCallout) {
      return;
    }

    trackEvent(TrackedEvent.AppCalloutBannerDismissed, {
      url: appCallout.primaryActionUrl,
    });

    await store.spaceAccountAppCallouts.dismissAppCallout({ appCallout });
  }, [appCallout, store.spaceAccountAppCallouts]);

  if (!appCallout) {
    return null;
  }

  return (
    <AppCalloutBannerContent
      iconKind={appCallout.iconKind}
      isDismissible={appCallout.isDismissible}
      primaryLabel={appCallout.primaryLabel}
      secondaryLabel={appCallout.secondaryLabel}
      inlineActionLabel={appCallout.inlineActionLabel}
      inlineActionUrl={appCallout.inlineActionUrl}
      primaryActionLabel={appCallout.primaryActionLabel}
      primaryActionUrl={appCallout.primaryActionUrl}
      primaryActionIconKind={appCallout.primaryActionIconKind}
      secondaryActionLabel={appCallout.secondaryActionLabel}
      secondaryActionUrl={appCallout.secondaryActionUrl}
      secondaryActionIconKind={appCallout.secondaryActionIconKind}
      tertiaryActionLabel={appCallout.tertiaryActionLabel}
      tertiaryActionUrl={appCallout.tertiaryActionUrl}
      tertiaryActionIconKind={appCallout.tertiaryActionIconKind}
      handleDismiss={handleDismiss}
    />
  );
});
